import { site, navLinks, peopleCats } from "@/mocks/gossip";

const colData = [
  { title: "内容分区", items: ["网红速递", "明星前线", "主播现场", "博主带货", "人物纵深"] },
  { title: "档案服务", items: ["当事人档案", "事件时间线", "热榜回顾", "围观风向"] },
  { title: "关于本站", items: ["网站介绍", "投稿爆料", "内容规范", "免责声明"] },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80">
      <div className="mx-auto max-w-7xl px-4 pt-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 border-b border-background-300/70 pb-10 md:grid-cols-4 lg:grid-cols-5">
          {/* brand */}
          <div className="col-span-2 lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">{site.brand}</span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">
              {site.tagline}。以社区讨论的视角围观网红、明星、主播与博主背后的热点，也让每一个当事人故事有迹可循。
            </p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {peopleCats.map((c) => (
                <a
                  key={c}
                  href="#feed"
                  className="chip bg-background-50 px-2.5 py-1 text-xs text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {c}
                </a>
              ))}
            </div>
          </div>

          {colData.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="mt-3 space-y-2.5">
                {col.items.map((it) => (
                  <li key={it}>
                    <a href="#feed" className="text-sm text-foreground-500 transition-colors hover:text-primary-600">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 py-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p className="flex items-center gap-1.5">
            <i className="ri-information-line text-primary-500"></i>
            本站内容以客观收集与社区讨论为主，理性吃瓜，不构成对任何人物或事件的最终定性。
          </p>
          <p className="sm:ml-auto">&copy; 2026 {site.brand} · 仅为静态展示示例</p>
        </div>
      </div>

      {/* bottom mini bar */}
      <div className="border-t border-background-300/60 bg-background-200/70">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            {navLinks.slice(1, 5).map((n) => (
              <a key={n.key} href={n.href} className="hover:text-primary-600">{n.label}</a>
            ))}
          </div>
          <div className="flex items-center gap-1 text-foreground-400">
            {["ri-weibo-line", "ri-wechat-line", "ri-qq-line", "ri-rss-line"].map((ic) => (
              <a
                key={ic}
                href="#top"
                aria-label="关注"
                className="grid h-8 w-8 items-center justify-center rounded-md text-lg transition-colors hover:bg-background-50 hover:text-primary-600"
              >
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}